import React from "react";
import { ArrowRightIcon } from "lucide-react";
import { CHECKOUT_URL } from "../data/content";
type CtaButtonProps = {
  label: string;
  caption?: string;
  id?: string;
  tone?: "light" | "dark";
};
export function trackCheckout() {
  window.fbq?.("track", "InitiateCheckout");
}
export function CtaButton({
  label,
  caption,
  id,
  tone = "light"
}: CtaButtonProps) {
  return <div id={id} className="mx-auto flex w-full max-w-xl flex-col items-center" data-id="element-11" data-mp="qkagd4rhb1td">
      <a href={CHECKOUT_URL} onClick={trackCheckout} className="group flex w-full items-center justify-center gap-3 rounded-2xl bg-brand px-5 py-5 text-center text-[16px] font-extrabold uppercase leading-tight tracking-wide text-white shadow-[0_14px_30px_-12px_rgba(20,115,230,0.85)] transition-[background-color,transform] duration-150 ease-out hover:bg-brand-dark active:scale-[0.98] focus:outline-none focus-visible:ring-4 focus-visible:ring-sky/50 sm:text-lg" data-id="element-12" data-mp="qi7hdv8clyci">
        <span data-id="element-13" data-mp="157n3gxwxpflv">{label}</span>
        <ArrowRightIcon className="h-5 w-5 shrink-0 transition-transform duration-150 ease-out group-hover:translate-x-1" aria-hidden="true" data-id="element-14" data-mp="35xo12ysgsalh" />
      </a>
      {caption && <p className={`mt-3 text-center text-sm ${tone === "dark" ? "text-white/70" : "text-muted"}`} data-id="element-15" data-mp="3exb23jha7ee0">{caption}</p>}
    </div>;
}